/**
 * All Servers API — backend call for the cross-campus All Servers page.
 *
 * Procedure: getpalcaredevices (empty campus_filter returns ALL campuses)
 */

import { apiFetch } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// READ operations
// ---------------------------------------------------------------------------

/**
 * Fetch all PalCare server devices across every campus.
 *
 * V1 procedure: getpalcaredevices
 * The empty campus_filter is what makes it return all campuses.
 */
export function fetchAllServers(campusId, readOnly = true) {
  return apiFetch({
    procedure: 'getpalcaredevices',
    reqType: 'stored',
    pKey: 'campus_id',
    pVal: campusId,
    payload: { campus_filter: '' },
    readOnly,
  });
}
